<template>
    <!-- 人员异常 -->
	<div class="person_box animate__animated animate__fadeIn">
		<div class="person">
			<div class="search_box">
				<div class="box_line">
					<div class="line_input">
						<div class="input_title">人员姓名</div>
						<input type="text" class="input_box" placeholder="请输入人员姓名" v-model="searchName" />
					</div>
					<div class="search-btn" @click="fnSearch"><span>搜索</span></div>
				</div>
			</div>
			<div class="cont_list">
				<div class="list_title">
					<div class="title_item">人员头像</div>
					<div class="title_item">人员姓名</div>
					<div class="title_item">异常原因</div>
					<div class="title_item">处理详情</div>
					<div class="title_item">创建时间</div>
					<div class="title_item">处理操作</div>
				</div>
				<div class="list_boxes">
					<div class="list_box">
						<div v-if="personnelData">
							<div class="box_line" v-for="(item, index) in personnelData" :key="index">
								<div class="list_item"><img :src="item.photo || 'http://cqzgzl.oss-cn-chengdu.aliyuncs.com/image/40fd31b9434de0d6cc965f1c2b475368.jpg'" /></div>
								<div class="list_item">{{ item.name }}</div>
								<div class="list_item" :title="item.reason"><span>{{ item.reason }}</span></div>
								<div class="list_item" :title="item.content"><span>{{ item.content }}</span></div>
								<div class="list_item">{{ item.create_at }}</div>
								<div class="list_item">
									<div v-if="item.state == 0">
										<div class="search-btn" @click="fnDealWith(item)"><span>处理</span></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="cont_page">
				<el-pagination
					background
					class="pagination"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="pageSizes"
					:page-size="pageSize"
					:current-page="currentPage"
					layout="total, sizes, prev, pager, next, jumper"
					:total="pageTotal"
				/>
			</div>
				<div class="dialog_handle animate__animated animate__fadeIn" v-show="dealWithWin">
					<el-dialog :modal="false" title="处理" v-if="dealWithWin" :visible.sync="dealWithWin" center style="text-align: center">
						<div style="text-align: center">
							<el-input style="width: 80%" type="textarea" :row="3" class="input" placeholder="请输入处理信息" v-model="setData.content" size="large"></el-input>
						</div>
						<div slot="footer" class="dialog-footer">
							<div class="btn_line">
								<div class="search-btn red" @click="dealWithWin = false"><span>取消</span></div>
								<div class="search-btn" @click="fnSetDealWith"><span>确定</span></div>
							</div>
						</div>
					</el-dialog>
				</div>
		</div>
	</div>
</template>
<script>
import request from '@/utils/request';
import APP from '@/utils/base';
import { getUserInfo } from '@/utils/auth';

export default {
	data() {
		return {
			pageSize: APP.PAGE.LIMIT,
			pageSizes: APP.PAGE.SIZE_OPTION,
			currentPage: APP.PAGE.SKIP_PAGE,
			pageTotal: 0,
			searchId: '', // 搜索人员ID
			searchName: '', // 搜索人员姓名
			searchCreate_atData: '', // 搜索创建时间
			searchCreate_at: '', // 创建时间的格式化
			defaultImg: 'http://cqzgzl.oss-cn-chengdu.aliyuncs.com/image/40fd31b9434de0d6cc965f1c2b475368.jpg', // 默认头像
			formLabelWidth: '120px',
			dealWithWin: false, // 处理详情弹窗
			setData: {
				content: '',
				id: null
			},
			personnelData: [] // 人员数据
		};
	},
	created() {
		this.fnInit();
	},
	methods: {
		// 初始化
		fnInit() {
			this.fnGetPersonnel(
				{
					page: this.currentPage,
					size: this.pageSize
				},
				res => {
					this.personnelData = res.data.query;
					this.pageTotal = res.data.count;
				}
			);
		},
		handleSizeChange(val) {
			this.pageSize = val;
			this.fnSearch();
		},
		handleCurrentChange(val) {
			this.currentPage = val;
			this.fnSearch();
		},
		// 获取所有人员
		fnGetPersonnel(_obj, _cb) {
			request({
				url: 'memberError/getErrorListData',
				method: 'GET',
				params: _obj
			})
				.then(res => {
					_cb && _cb(res);
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		//搜索
		fnSearch() {
			if (this.searchCreate_atData != '') {
				this.searchCreate_at = this.searchCreate_atData[0] + ',' + this.searchCreate_atData[1];
			} else {
				this.searchCreate_at = '';
			}
			this.fnGetPersonnel(
				{
					page: this.currentPage,
					size: this.pageSize,
					name: this.searchName,
					id: this.searchId,
					create_at: this.searchCreate_at
				},
				res => {
					this.personnelData = res.data.query;
					this.searchCreate_atData = '';
					this.pageTotal = res.data.count;
				}
			);
		},
		// 处理详情
		fnDealWith(_data) {
			this.setData.id = _data.id;
			this.dealWithWin = !this.dealWithWin;
		},
		// 处理详情提交
		fnSetDealWith() {
			if (this.setData.content.length < 4) {
				this.$message.error('原因说明长度至少为四个字！');
				return;
			}
			request({
				url: 'memberError/editError',
				method: 'POST',
				data: this.setData
			})
				.then(res => {
					this.fnSearch();
					this.dealWithWin = false;
					this.$message.success(res.data);
					this.setData.content = '';
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		}
	}
};
</script>
<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
.person_box {
	width: 1920px;
	height: 858px;
	position: relative;
	overflow: hidden;

	.person {
		position: absolute;
		left: 0;
		right: -20px;
		top: 0;
		bottom: 0;
		overflow-x: hidden;
		overflow-y: auto;
	}
}

.search_box {
	height: 30px;
	width: 1880px;
	margin-top: 24px;
	margin-left: 20px;
	@include flex-box(space-between, center, column);
	.box_line {
		width: 1880px;
		height: 32px;
		@include flex-box(flex-start, center);
		.line_input {
			min-width: 280px;
			height: 30px;
			margin-right: 10px;
			border-top-right-radius: 1px;
			border-bottom-right-radius: 1px;
			background-color: rgba(49, 88, 128, 0.4);
			@include flex-box(flex-start, center);
			.input_title {
				width: 69px;
				height: 30px;
				font-size: 14px;
				color: #9bf9fc;
				border-radius: 2px;
				background-color: rgba(155, 249, 252, 0.1);
				@include flex-box(center, center);
			}
			.input_box {
				width: 211px;
				height: 30px;
				line-height: 30px;
				padding-left: 15px;
				color: rgba(77, 180, 244, 0.7);
				font-size: 12px;
				border-radius: 2px;
				outline: none;
				background: transparent;
				border: none;
				&::-webkit-input-placeholder {
					color: rgba(77, 180, 244, 0.7);
				}
				&::-moz-placeholder {
					/* Mozilla Firefox 19+ */
					color: rgba(77, 180, 244, 0.7);
				}
				&:-moz-placeholder {
					/* Mozilla Firefox 4 to 18 */
					color: rgba(77, 180, 244, 0.7);
				}
				&:-ms-input-placeholder {
					/* Internet Explorer 10-11 */
					color: rgba(77, 180, 244, 0.7);
				}
			}
		}
	}
}
.cont_list {
	margin-top: 29px;
	margin-left: 28px;
	width: 1864px;
	height: 679px;
	border-radius: 10px;
	background-color: rgba(29, 68, 149, 0.1);
	.list_title {
		width: 1864px;
		height: 48px;
		background: url(../../../assets/img/per_list_bg.png) no-repeat;
		background-size: 100% 100%;
		@include flex-box(flex-start, center);
		.title_item {
			height: 48px;
			@include flex-box(center, center);
			&:nth-child(1) {
				width: 196px;
                margin: 0 4px 0 40px;
			}
			&:nth-child(2) {
				width: 196px;
				margin-right: 4px;
			}
			&:nth-child(3) {
				width: 396px;
				margin-right: 4px;
			}
			&:nth-child(4) {
				width: 396px;
				margin-right: 4px;
			}
			&:nth-child(5) {
				width: 396px;
				margin-right: 4px;
			}
            &:nth-child(6) {
            	width: 184px;
            }
		}
	}
	.list_boxes {
		width: 1864px;
		height: 645px;
		position: relative;
		overflow: hidden;
		.list_box {
			position: absolute;
			left: 0;
			right: -25px;
			top: 0;
			bottom: 0;
			overflow-x: hidden;
			overflow-y: auto;
			.box_line {
				width: 1784px;
				height: 70px;
				margin: 7px 0 0 40px;
				font-size: 16px;
				color: #ffffff;
				border-bottom: 1px dashed #1d4495;
				@include flex-box(flex-start, center);
				&:hover{
					background-color: rgba(49, 88, 128, 0.4);
				}
				.list_item {
					height: 70px;
					text-align: center;
					@include flex-box(center, center);
                    &:nth-child(1) {
                        width: 196px;
                        margin-right: 4px;
                    }
                    &:nth-child(2) {
                        width: 196px;
                        margin-right: 4px;
                    }
                    &:nth-child(3) {
                        width: 396px;
                        margin-right: 4px;
                    }
                    &:nth-child(4) {
                        width: 396px;
                        margin-right: 4px;
                    }
                    &:nth-child(5) {
                        width: 396px;
                        margin-right: 4px;
                    }
                    &:nth-child(6) {
                        width: 184px;
                    }
					img {
						width: 40px;
						height: 40px;
						border-radius: 50%;
					}
					span{
						width: 100%;
						cursor: pointer;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space:nowrap;
					}
					div {
						@include flex-box(center, center);
					}
				}
			}
		}
	}
}
.box_line {
	>>> .el-input__inner {
		width: 211px;
		height: 30px;
		border-radius: 2px;
		border: none;
		color: rgba(77, 180, 244, 0.7);
		background: transparent;
		&::-webkit-input-placeholder {
			color: rgba(77, 180, 244, 0.7);
		}
		&::-moz-placeholder {
			/* Mozilla Firefox 19+ */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-moz-placeholder {
			/* Mozilla Firefox 4 to 18 */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-ms-input-placeholder {
			/* Internet Explorer 10-11 */
			color: rgba(77, 180, 244, 0.7);
		}
	}
	>>>.el-select__caret {
		color: rgba(77, 180, 244, 0.7);
	}
	>>> .el-select-dropdown {
		background-color: rgba(77, 180, 244, 0.2);
		border: 1px solid rgba(77, 180, 244, 1);
	}
	>>> .popper__arrow {
		border-bottom-color: rgba(77, 180, 244, 1) !important;
	}
	>>> .el-select-dropdown__item {
		color: rgba(77, 180, 244, 0.7);
	}
	>>> .el-select-dropdown__item:hover {
		color: #409eff;
	}
	>>> .el-select-dropdown__item.hover {
		color: #409eff;
	}
	>>> .el-input__icon {
		color: rgba(77, 180, 244, 0.7);
	}
	>>> .el-range-input {
		background: transparent;
		color: rgba(77, 180, 244, 0.7);
		&::-webkit-input-placeholder {
			color: rgba(77, 180, 244, 0.7);
		}
		&::-moz-placeholder {
			/* Mozilla Firefox 19+ */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-moz-placeholder {
			/* Mozilla Firefox 4 to 18 */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-ms-input-placeholder {
			/* Internet Explorer 10-11 */
			color: rgba(77, 180, 244, 0.7);
		}
	}
	>>> .el-range-separator {
		color: rgba(77, 180, 244, 0.7);
	}
}
.dialog_handle {
	.btn_line {
		@include flex-box(center, center);
	}
	>>> .el-dialog {
		width: 800px;
		height: 500px;
		margin-top: 20vh !important;
		background-color: rgba(9, 17, 32, 1);
		border: 1px solid rgba(58, 116, 221, 1);
	}
	>>> .el-form-item__label {
		color: #4db4f4;
	}
	>>> .el-dialog__title {
		color: #4db4f4;
	}
	>>> .el-dialog__close {
		color: #4db4f4;
	}
	>>> .el-textarea__inner {
		max-height: 325px;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/Abnormal/abnormalDefault/index.vue